import metadataQueryKeys from "./metadataQueryKeys";

type ListScope = "list" | "related" | "editor" | "bridge";

export const queryKeys = {
    records: {
        all: (table: string) => ["records", table] as const,
        lists: (table: string) => ["records", table, "list"] as const,
        list: (table: string, scope: ListScope, params?: unknown, sort?: unknown) =>
            ["records", table, "list", { scope, params: params ?? null, sort: sort ?? null }] as const,
        detail: (table: string, id: string) => ["records", table, "detail", id] as const,
        lookup: (table: string, kind: string, ...args: unknown[]) => ["records", table, "lookup", kind, ...args] as const,
        config: (configTable: string, params?: unknown) => ["records", configTable, "config", params ?? null] as const,
        acl: (table: string, action: "create" | "update") => ["records", table, "acl", action] as const,
    },
    menu: { tree: () => ["records", "sys_menu_item", "menu"] as const },
    session: { me: () => ["session", "me"] as const },
    preferences: { byUser: (userId?: string | null) => ["records", "sys_user_preference", "by-user", userId ?? null] as const },
    metadata: metadataQueryKeys,
};

export const NEW_RECORD_ID = "__new__";
export const isRelatedListQueryKey = (key: readonly unknown[]) =>
    key[0] === "records" && key[2] === "list" && (key[3] as { scope?: string } | undefined)?.scope === "related";

export default queryKeys;
